import React, { Fragment } from 'react'

import './styles.scss'

import { IntroProps } from '../types'

import backgroundImg from './img/background.png'
import brushImg from './img/brush.png'
import tornImg from './img/torn.svg'

import { CheckImagesLoaded } from '../utils/CheckImagesLoaded'

const Intro = ({
  coupleData: { coupleSingleName, coupleSimplifiedName, weddingDate },
  buttonMessage,
  warningMessage,
  background,
  delay = 0,
  onSkipIntro,
  onLoad,
}: IntroProps) => {
  const text =
    new Date() > new Date(weddingDate.timestamp)
      ? 'JÁ SE CASARAM'
      : 'VÃO SE CASAR'
  return (
    <CheckImagesLoaded delay={delay} onLoad={onLoad} className="intro281">
      <div className="intro281mobile screen">
        <img
          src={background || backgroundImg}
          className="main-background-PrchDK"
        />
        <div className="mask-PrchDK"></div>
        <img src={tornImg} className="torn-PrchDK" />
        <div className="container-center-horizontal">
          <h1 className="notranslate me-Y5oIxW bp2-intro281-animate-enter2">
            {coupleSimplifiedName.bride[0]}
            {coupleSimplifiedName.groom && (
              <Fragment> &amp; {coupleSimplifiedName.groom[0]}</Fragment>
            )}
          </h1>
          <div className="content-PrchDK">
            <img
              src={brushImg}
              className="brush-Y5oIxW bp2-intro281-animate-enter"
            />
            <div className="std-Y5oIxW bp2-intro281-animate-enter1">{text}</div>
          </div>
        </div>
        <div className="container-center-horizontal">
          <div className="button-PrchDK">
            <p
              className="site-de-casamento-e-8uSeGz"
              dangerouslySetInnerHTML={{ __html: warningMessage }}
            />
            <div className="button-8uSeGz">
              <div className="button-jGCQB8"></div>
              <div className="pular-introduo-jGCQB8">{buttonMessage}</div>
            </div>
          </div>
        </div>
      </div>
      <div className="intro281desktop screen">
        <img
          src={background || backgroundImg}
          className="main-background-uDyuh9 bp1-intro281-animate-enter"
        />
        <div className="mask-uDyuh9"></div>
        <img src={tornImg} className="torn-uDyuh9" />
        <div className="container-center-horizontal">
          <h1 className="notranslate me-SEcx40 bp1-intro281-animate-enter3">
            {coupleSingleName.bride}
            {coupleSingleName.groom && (
              <Fragment> &amp; {coupleSingleName.groom}</Fragment>
            )}
          </h1>
          <div className="content-uDyuh9">
            <img
              src={brushImg}
              className="brush-SEcx40 bp1-intro281-animate-enter1"
            />
            <div className="std-SEcx40 bp1-intro281-animate-enter2">{text}</div>
          </div>
        </div>
        <div className="container-center-horizontal">
          <div className="button-uDyuh9">
            <p
              className="site-de-casamento-e-2xypQS"
              dangerouslySetInnerHTML={{ __html: warningMessage }}
            />
            <div className="button-2xypQS">
              <div className="button-DBvx5S"></div>
              <div className="pular-introduo-DBvx5S" onClick={onSkipIntro}>
                {buttonMessage}
              </div>
            </div>
          </div>
        </div>
      </div>
    </CheckImagesLoaded>
  )
}

export default Intro
